import {
  Component,
  OnDestroy,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { appAnimations } from '@shared/animations';
import { NavigationService } from '../../services/src/navigation.service';
import { MatSidenavHelperService } from '@shared/services';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: appAnimations,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NavigationComponent implements OnDestroy, OnInit {
  navigationModel: any[];
  navigationModelChangeSubscription: Subscription;
  sidebarSubscription: Subscription;
  horizontalNavItems: any[] = [];
  pagesMenu: any[];
  pagesModel: any = {};
  sideNav: MatSidenav;

  constructor(
    private matSidenavService: MatSidenavHelperService,
    private appNavigationService: NavigationService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.sideNav = this.matSidenavService.getSidenav('game-menu');
    this.navigationModelChangeSubscription =
      this.appNavigationService.onNavigationModelChange.subscribe(() => {
        this.pagesModel = this.appNavigationService.model;
        this.handle();
      });
  }

  handle() {
    this.pagesMenu = this.pagesModel.filter(
      (i) => (i.type === 'item' || i.type === 'programItem') && i.active === true,
    );
  }

  ngOnDestroy() {
    this.navigationModelChangeSubscription.unsubscribe();
  }
}
